<!--
 * @Author: your name
 * @Date: 2020-11-08 22:39:33
 * @LastEditTime: 2020-11-23 21:09:02
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /mall-wap-vue/src/views/product/detail/components/DetailsInfo/index.vue
-->
<template>
  <div class="con">
    <div v-html="mallretailspu.description.description"></div>
  </div>
</template>
<script>
export default {
  data() {
    return {};
  },
  computed: {
    mallretailspu() {
      return this.$store.getters.mallretailspu;
    }
  }
};
</script>
<style lang="less" scoped>
.con {
  margin-top: 10px;
  background: #fff;
  // background: #bf9264;
  border-radius: 6px;
  // opacity: 0.6;
  // height: 355px;
  word-break: break-all;
  font-size: 14px;
  text-align: left;
  ::v-deep img {
    width: 100%;
    height: 100%;
    display: block;
    padding: 0;
    margin: 0;
    border: none;
  }
  p {
    display: block;
    margin: 0;
    padding: 0;
    -webkit-margin-before: 1em;
    -webkit-margin-after: 1em;
    -webkit-margin-start: 0px;
    -webkit-margin-end: 0px;
  }
}
</style>
